module.exports = __webpack_public_path__ + "img/WhatsApp.bca55c09.svg";